module.exports = __webpack_public_path__ + "img/golden-coins-yaowarat-pale-ale.791cee51.png";